var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _polygon, _path13, _polygon2, _path14, _path15, _circle2, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawHelpfulSignRe8Ms5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 740.67538,
    height: 393.24484,
    viewBox: "0 0 740.67538 393.24484",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M839.794,644.688H704.70543s-2.73829-40.16148,13.46321-40.61786,14.376,17.79884,34.68494-7.3021,44.95347-23.73178,48.14814-8.8994-6.16113,26.69826,10.95312,23.04724S853.71365,616.84878,839.794,644.688Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M836.91517,614.39035A47.59678,47.59678,0,0,0,789.02,642.72778c-.764,1.75234,1.81992,3.28146,2.59041,1.51416a44.63926,44.63926,0,0,1,45.30474-26.85159c1.9222.17349,1.91046-2.82757,0-3Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M717.14448,605.68689a48.98451,48.98451,0,0,1,11.63987,36.71142c-.18814,1.92007,2.81313,1.90706,3,0a51.92686,51.92686,0,0,0-12.51855-38.83274c-1.27058-1.45834-3.385.67087-2.12132,2.12132Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M790.99105,579.37218a200.18745,200.18745,0,0,0-20.50363,47.685q-2.01759,7.1338-3.49241,14.40445c-.38444,1.88468,2.50663,2.69084,2.89283.79752a197.0383,197.0383,0,0,1,16.69625-48.56191q3.25994-6.5332,6.99737-12.81086a1.50111,1.50111,0,0,0-2.59041-1.51415Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M898.786,396.25072V501.688H612.75933a8.971,8.971,0,0,1-8.97338-8.97338V387.27734H889.81256A8.971,8.971,0,0,1,898.786,396.25072Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#3ebfbe"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M969.147,646.62242H230.853a1.19069,1.19069,0,0,1,0-2.38137H969.147a1.19068,1.19068,0,0,1,0,2.38137Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 534.62364,
    y: 248.3104,
    width: 2,
    height: 144,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M918.786,502.688h-307a9.0103,9.0103,0,0,1-9-9v-129a9.01031,9.01031,0,0,1,9-9h307a9.01032,9.01032,0,0,1,9,9v129A9.01031,9.01031,0,0,1,918.786,502.688Zm-307-145a7.00786,7.00786,0,0,0-7,7v129a7.00785,7.00785,0,0,0,7,7h307a7.00786,7.00786,0,0,0,7-7v-129a7.00787,7.00787,0,0,0-7-7Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M833.786,423.688h-181a3,3,0,0,1,0-6h181a3,3,0,0,1,0,6Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M833.786,448.688h-181a3,3,0,0,1,0-6h181a3,3,0,0,1,0,6Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M833.786,473.688h-181a3,3,0,0,1,0-6h181a3,3,0,0,1,0,6Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 696.83492,
    cy: 102.89185,
    r: 32.86662,
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M926.634,366.16417l-16.44762-16.44759a2.85816,2.85816,0,0,1,4.04205-4.042l12.13205,12.13207,38.71407-44.14742a2.85787,2.85787,0,0,1,4.29742,3.76853Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#3ebfbe"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M376.33032,330.68011s20.25359-12.79174,39.44121,2.132L428.56328,466.0594s-47.96905,37.30926-59.69481,2.132Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "141.723 380.162 129.463 380.161 125.38 333.046 141.725 332.874 141.723 380.162",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.70626,376.65821h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H105.8194a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,120.70626,376.65821Z",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.037 380.162 198.297 380.161 204.129 332.873 186.035 332.874 186.037 380.162",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M413.07226,630.03579H451.603a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H427.95912a14.88686,14.88686,0,0,1-14.88686-14.88686v0A0,0,0,0,1,413.07226,630.03579Z",
    transform: "translate(635.04204 1021.56114) rotate(179.99738)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M344.884,466.59239l10.65978,158.83083,16.52267-.533L393.919,497.50578l20.25359,125.78548,19.18762,1.066,5.32989-164.16072S357.67569,442.07488,344.884,466.59239Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.52177,
    cy: 39.25824,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M380.06124,325.88321l-6.39587,4.26391s-26.64946,0-28.78142,15.98968-7.99484,125.2525-1.599,125.2525,7.46185-8.52783,7.46185-8.52783,4.26392,1.066,12.79174,9.59381,13.85773,8.52783,17.05566-4.26392,24.51751-110.86178,4.26392-128.98342Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M410.97463,325.88321l6.39587,4.26391s26.64947,0,28.78142,15.98968,7.99484,125.2525,1.599,125.2525-7.46185-8.52783-7.46185-8.52783-4.26391,1.066-12.79174,9.59381-13.85773,8.52783-17.05566-4.26392-24.51751-110.86178-4.26392-128.98342Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M375.25587,307.61177a13.36948,13.36948,0,0,1,10.14531-22.56406c3.39627.11351,6.59648,1.50343,9.83794,2.52344a32.53464,32.53464,0,0,0,15.28492,1.37639,20.40971,20.40971,0,0,0,13.01641-7.68569c3.03878-4.17652,3.98637-9.9694,1.83962-14.66717-2.47835-5.42343-8.26757-8.41183-13.71368-10.83993a25.06258,25.06258,0,0,0-6.96241-2.28755,8.92876,8.92876,0,0,0-6.92634,1.746c-1.53041,1.31629-2.42738,3.29481-4.09275,4.43555-1.87468,1.28409-4.30991,1.25039-6.5709,1.47672a25.20451,25.20451,0,0,0-12.2076,45.54",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M458.91841,483.054a10.7427,10.7427,0,0,0-.87606-16.44932l-.28893-28.18678L443.00284,441.216l-.54832,28.08671A10.80091,10.80091,0,0,0,458.91841,483.054Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#ffb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M355.91841,478.054a10.7427,10.7427,0,0,0-.87606-16.44932l-.28893-28.18678L340.00284,436.216l-.54832,28.08671A10.80091,10.80091,0,0,0,355.91841,478.054Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#ffb8b8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M442.421,344.53783l3.83518,2.4302s15.78617,60.45519,15.88542,101.50273c0,0-20.78658,10.12679-23.98452,2.66494S442.421,344.53783,442.421,344.53783Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M348.61487,344.53783l-3.83518,2.4302s-13.73734,60.45519-10.02254,100.96974c0,0,21.85256,10.12679,25.0505,2.66494S348.61487,344.53783,348.61487,344.53783Z",
    transform: "translate(-229.66231 -253.37758)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawHelpfulSignRe8Ms5);
export default __webpack_public_path__ + "static/media/undraw_helpful_sign_re_8ms5.418eb39686e8f1eca384085cbaf3e075.svg";
export { ForwardRef as ReactComponent };